export const Videos=[
    {
        videoUrl:"https://www.youtube.com/embed/mtCSzprQCpo",
        thumbnailUrl:"https://img.youtube.com/vi/mtCSzprQCpo/0.jpg",
        title:"Betrayal In the Wild",
        description:"This is short documentary and my first one. This was created back in 2020. This is about a squirrel trying to get food for the day where her food gets stolen and she faces something unexpected",
        duration:"2:40"

    },
    
    {
        videoUrl:"https://www.youtube.com/embed/MAtMYz3HzXc",
        thumbnailUrl:"https://img.youtube.com/vi/MAtMYz3HzXc/0.jpg",
        title:"Insect eaten by insect",
        description:"Well it is an unsaid rule of the nature. The better one survives. In tthis video a small and weak insect is eaten by another one because this is how nature and life works",
        duration:"0:23"

    },

    {
        videoUrl:"https://www.youtube.com/embed/L_T5vEC_xXY",
        thumbnailUrl:"https://img.youtube.com/vi/L_T5vEC_xXY/0.jpg",
        title:"Old World Flycatcher",
        description:"This is video containing some information about the bird : \"Old World Flycatcher\"",
        duration:"0:23"

    },

    {
        videoUrl:"https://www.youtube.com/embed/sElzaa7lOME",
        thumbnailUrl:"https://img.youtube.com/vi/sElzaa7lOME/0.jpg",
        title:"The Stare",
        description:"This is video containing some information about the bird : \"Old World Flycatcher\"",
        duration:"0:13"

    },
    {
        videoUrl:"https://www.youtube.com/embed/WO6hkFj4t00",
        thumbnailUrl:"https://img.youtube.com/vi/WO6hkFj4t00/0.jpg",
        title:"CK Watch",
        description:"This is video containing some information about the bird : \"Old World Flycatcher\"",
        duration:"0:18"

    },
]